module.exports = __webpack_public_path__ + "img/CAL-IEC-Case_closed.5f48d922.webp";